import PendingEvaluations from '@/models/PendingEvaluations';

const GET_PENDING_EVALUATIONS = 'get_pendingEvaluations';
const GET_PENDING_EVALUATIONS_REQUEST = 'get_pendingEvaluations_request';
const GET_PENDING_EVALUATIONS_SUCCESS = 'get_pendingEvaluations_success';
const GET_PENDING_EVALUATIONS_ERROR = 'get_pendingEvaluations_error';

export { GET_PENDING_EVALUATIONS };

export default {
    state: {
        pendingEvaluations: [],
        loading: false,
        pendingEvaluationsErrors: [],
        pendingEvaluationsMeta: {},
    },
    mutations: {
        [GET_PENDING_EVALUATIONS_REQUEST]: (state) => {
            state.pendingEvaluations = [];
            state.loading = true;
            state.pendingEvaluationsErrors = [];
        },
        [GET_PENDING_EVALUATIONS_SUCCESS]: (state, { pendingEvaluations, meta }) => {
            state.pendingEvaluations = pendingEvaluations;
            state.loading = false;
            state.pendingEvaluationsErrors = [];
            state.pendingEvaluationsMeta = meta;
        },
        [GET_PENDING_EVALUATIONS_ERROR]: (state, { errors }) => {
            state.pendingEvaluations = [];
            state.loading = false;
            state.pendingEvaluationsErrors = errors;
            state.pendingEvaluationsMeta = {};
        },
    },
    actions: {
        [GET_PENDING_EVALUATIONS]: ({ commit, state }, { params = {} }) => {
            commit(GET_PENDING_EVALUATIONS_REQUEST);
            return new Promise((resolve, reject) => {
                // If no page specified at dispatch
                if (!params.page) {
                    // Use the current one if present, the first one othewise
                    if (state.pendingEvaluationsMeta.current_page) {
                        params.page = state.pendingEvaluationsMeta.current_page;
                    } else {
                        params.page = 1;
                    }
                }

                PendingEvaluations.collection(params)
                    .then(({items, meta}) => {
                        const pendingEvaluations = items;
                        commit(GET_PENDING_EVALUATIONS_SUCCESS, { pendingEvaluations, meta });
                        resolve(items);
                    })
                    .catch(({ status, errors }) => {
                        commit(GET_PENDING_EVALUATIONS_ERROR, { errors });
                        reject({ status, errors });
                    });
            });
        },
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/pending-evaluations.js